import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, CheckCircle } from "@phosphor-icons/react";

export default function AudienceInfo({ tag, title, promise, bullets, note, testid, image, imageAlt }) {
  return (
    <div className="min-h-screen bg-[#F9FAFB] text-slate-900">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <span className="h-7 w-7 rounded-sm bg-slate-900 flex items-center justify-center text-white font-heading font-black text-sm">E</span>
            <span className="font-heading font-bold tracking-tight text-lg">Eligvia</span>
          </Link>
          <div className="flex items-center gap-1">
            <Link to="/help"><Button variant="ghost" className="text-slate-700 px-3" data-testid="audience-help-btn">Help</Button></Link>
            <Link to="/login"><Button variant="ghost" className="text-slate-700 px-3">Sign in</Button></Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-16" data-testid={testid}>
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-6"><ArrowLeft /> Back</Link>
        <p className="font-mono-num text-xs uppercase tracking-[0.2em] text-slate-500">{tag} · Early access</p>
        <h1 className="mt-3 font-heading font-black tracking-tight text-4xl sm:text-5xl leading-tight">{title}</h1>
        <p className="mt-5 text-lg text-slate-600 leading-relaxed max-w-3xl">{promise}</p>

        {image && (
          <img src={image} alt={imageAlt || title} data-testid="audience-cover-image"
               className="mt-8 w-full rounded-lg border border-slate-200 shadow-sm" />
        )}

        <div className="mt-8 rounded-lg border border-slate-200 bg-white p-6">
          <p className="font-heading font-bold">What you'll get</p>
          <ul className="mt-3 space-y-2.5">
            {bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-2.5 text-sm text-slate-700">
                <CheckCircle weight="fill" className="text-emerald-600 mt-0.5 shrink-0" /> {b}
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-8 rounded-lg bg-slate-900 text-white p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <p className="font-heading font-bold text-lg">Coming in the next release</p>
            <p className="text-sm text-slate-300 mt-1">{note}</p>
          </div>
          <a href="/help">
            <Button className="bg-white text-slate-900 hover:bg-slate-100" data-testid="early-access-btn">Request early access</Button>
          </a>
        </div>
      </main>
    </div>
  );
}
